import React from 'react';
import { Image, Icon, Header, Button } from 'semantic-ui-react';
import moment from 'moment';

import '../styles/speaker-modal.scss';

const hashTagReplace = (str) => str.replace(
    /#(\S*)/g,
    '#<a target="_blank" class="link" href="https://www.instagram.com/explore/tags/$1/">$1</a>'
  );

const SpeakerModal = (props) => {
  const { modal } = props;
  const { speaker } = modal;
  const show = modal.show === true ? 'block' : 'none';
  const text = hashTagReplace(speaker.bio);
  //   const date = moment.unix(modal.image.created_time).format('YYYYMMDD')

  return (
    <div
      className="modal"
      style={{ display: show }}
      onClick={props.handleClose}
    >
      <div className="modal__content">
        <button className="modal__close" onClick={props.closeModal}>
          <Icon name="close" />
        </button>
        <div className="modal__image">
          <Image fluid circular src={speaker.picture} />
          <h2 className="modal__speaker-name">{speaker.name}</h2>
          <h3 className="modal__speaker-title">{speaker.title}</h3>
          <h3 className="modal__speaker-institution">{speaker.institution}</h3>
        </div>
        <div className="modal__body">

          <div className="modal__caption">
            <div dangerouslySetInnerHTML={{ __html: text }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpeakerModal;



// WEBPACK FOOTER //
// ./src/components/speaker-modal.js